import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Insights {

  /**
   * Retrieves the storage insights for a given project.
   * @param {number} id The project ID for which the insights should be retrieved.
   */
  static async loadStorageInsights(id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/insights/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data) {
        resolve(data.data);
      }).catch(function(error) {
        if (error.response && error.response.data) {
            resolve(error.response.data);
        } else {
            resolve({ status: 500, message: "Network error" });
        }
      });
    });
  }
}
